import { useMemo } from "react";

export const useContainerClasses = (accountId: string | undefined) => {
  const upperClass: string = useMemo(() => {
    return !accountId ? "py-6 pr-8 pl-2 table-page-content" : "w-100";
  }, [accountId]);

  const lowerClass: string = useMemo(() => {
    return `d-block w-100 pb-${!accountId ? "6" : "4"}`;
  }, [accountId]);

  return { upperClass, lowerClass };
};
